export default function () {
  return {
    errors: {},
    specialization: {
      id: null,
      name: '',
    },
  }
}
